import { createSelector } from "@reduxjs/toolkit";

import type { ButtonKeys } from "state/pilot/slice";
import type { AppState } from "../store";

const getUiFeedbackState = (state: AppState) => state.uiFeedback;

export const getFeedbackForKey = (state: AppState, key: ButtonKeys) => state.uiFeedback[key];
export const getZoomFeedback = createSelector(
  getUiFeedbackState,
  ({ zoomBlockers, digitalZoomAvailable, zoomLevel }) => ({
    zoomBlockers,
    digitalZoomAvailable,
    zoomLevel,
  })
);
